export const PREDICTION = 'prediction'
export const CLOSE = 'Close'
export const ACTUAL = 'actual'
export const COMBINED = 'combined'
export const SEEDATA = 'seedata'
export const PREDICTION_CLEAR='prediction_clear'

export const GRAPH_CLEAR='close'
export const COMBINEDSTACKEDBARCHART = 'combinedstackedbarchart'
export const COMBINEDGROUPBARCHART = 'combinedgroupbarchart'

export const PREDICTION_HISTOGRAM_DRAW_BAR = 'prediction_histogram_draw_bar'
export const PREDICTION_HISTOGRAM_CONFIG_BINS = 8

export const PREDICTION_HISTOGRAM_DRAW_PAINT = 'prediction_histogram_draw_paint'

export const PREDICTION_HISTOGRAM_CANVAS_PENCIL = 'prediction_histogram_canvas_pencil'
export const PREDICTION_HISTOGRAM_CANVAS_PAINT = 'prediction_histogram_canvas_paint'
export const PREDICTION_HISTOGRAM_CANVAS_ERASER = 'prediction_histogram_canvas_eraser'
export const PREDICTION_HISTOGRAM_CANVAS_CLEAR = 'prediction_histogram_canvas_clear'

export const HISTOGRAM_CHART = 'Histogram'
export const SCATTERPLOT_CHART = 'Scatterplot'
export const PARALLEL_COORDINATES_CHART = 'parallelCoordinates'
export const BAR_CHART='BarChart'
export const LINE_CHART='LineChart'


//sans-serif->font family for the attributes
//#B0D5E3 -.>attributes in background
//border top ->8px solid rgb(189, 189, 189)
//background svg cross -> dim the color(grey)
//svg cross -> reduce the arrow size..